import { IProductFileWithFile } from "@evennt-tech/api-v2-core";

/**
 * The image of the option the exhibitor picked; `undefined` when the line has
 * no option image, so the caller falls back to the product's own image.
 */
export const findOptionImageUrl = (
  productImages: Pick<IProductFileWithFile, "id" | "file">[],
  imageId?: string
): string | undefined =>
  imageId
    ? productImages.find(({ id }) => id === imageId)?.file?.url
    : undefined;
